import { DomainBase } from "./DomainBase";

 export class AccountTypeClass extends DomainBase {
    constructor() {
        super();
        this.name = "";
       
    }
}